import { IntegrationOutlined, PauseOutline, PlayOutlined, SuspendedOutline } from 'assets/icons';
import Loader from 'components/common/loader/Loader';
import { CardWrap } from '../CardWrap';
import * as S from './StatusCounter.styled';

const iconType = {
  play: PlayOutlined,
  pause: PauseOutline,
  suspended: SuspendedOutline,
  integration: IntegrationOutlined,
};

export const StatusCounter = ({
  title,
  icon = 'play',
  type = 'green',
  value = 0,
  numCols = 1,
  isFetching,
  onClick,
}) => {
  const Icon = iconType[icon];

  return (
    <CardWrap
      numCols={numCols}
      type={isFetching ? 'none' : type}
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : undefined}
    >
      {isFetching ? (
        <S.LoaderWrap>
          <Loader.Local delay={0} />
        </S.LoaderWrap>
      ) : (
        <S.Wrap>
          <S.Title>{title}</S.Title>
          <S.Value>{value}</S.Value>
          {Icon && (
            <S.IconWrap>
              <Icon />
            </S.IconWrap>
          )}
        </S.Wrap>
      )}
    </CardWrap>
  );
};
